import _get from 'lodash/get'
import API from '../../shared/constants'
import {DateTime} from 'luxon'
import {
  _getAggregateRating,
  _getContentRating,
  _getCountryOfOrigin,
  _getCoverUrl,
  _getFipRouteName,
  _getFipRouteParams,
  _getJsonLanguagesFromList,
  _getPersons,
  _getReleaseDate,
  _getTrailer
} from '../../shared/utils'

/**
 * Get movie rich data
 * @param item
 * @param router
 * @param baseUrl
 * @returns {{image: *, '@type': string, author: {'@type': string, name: string}[], description, inLanguage: {'@type': string, name: string}[], subtitleLanguage: {'@type': string, name: string}[], '@context': string, url: *, duration: string, actor: {'@type': string, name: string}[], name, genre, contentRating: string}}
 */
function getMovie (item, router, baseUrl) {
  const url = baseUrl + router.resolve({ name: _getFipRouteName(item.type, item.videoType), params: _getFipRouteParams(item) }).href
  const image = _getCoverUrl(item, API.IMAGE_TYPE.COVER)
  const name = _get(item, 'title', null)
  const startDate = item.diffusionDate ? DateTime.fromMillis(item.diffusionDate * 1000).setLocale('fr').toString() : ''
  const endDate = item.diffusionDate && item.duration ? DateTime.fromMillis((item.diffusionDate + item.duration) * 1000).setLocale('fr').toString() : ''

  return {
    '@context': 'http://schema.org',
    '@type': 'Movie',
    url,
    name,
    image,
    startDate,
    endDate,
    genre: _get(item, 'genres', _get(item, 'genre', [])),
    duration: `PT${_get(item, 'duration', 0)}M`,
    description: _get(item, 'synopsis', ''),
    contentRating: _getContentRating(item),
    inLanguage: _getJsonLanguagesFromList(_get(item, 'definitions[0].languages', [])),
    subtitleLanguage: _getJsonLanguagesFromList(_get(item, 'definitions[0].subtitles', [])),
    ..._getAggregateRating(item),
    ..._getTrailer(item, url, image, name),
    ..._getCountryOfOrigin(item),
    ..._getPersons(item),
    ..._getReleaseDate(item)
  }
}

export {
  getMovie
}
